/* Scratch Repair direct VIN -> private line-item property (V3, 2026-08-20) */
(function () {
  'use strict';
  if (window.__SR_VIN_DIRECT_V3__) return;
  window.__SR_VIN_DIRECT_V3__ = true;

  var params = new URLSearchParams(window.location.search);
  var reg = cleanReg(params.get('reg') || params.get('registration') || '');
  var lookupPromise = null;

  function cleanReg(v) {
    return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10);
  }

  function cleanVin(v) {
    return String(v || '').toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '').slice(0, 25);
  }

  function findVin(data) {
    if (!data || typeof data !== 'object') return '';
    var direct = [
      data.vin, data.VIN, data.Vin,
      data.vinNumber, data.VINNumber,
      data.vehicleIdentificationNumber,
      data.chassisNumber, data.chassis_number
    ];
    for (var i = 0; i < direct.length; i++) {
      var v = cleanVin(direct[i]);
      if (v.length >= 11) return v;
    }
    var nestedKeys = ['data', 'vehicle', 'result', 'details'];
    for (var j = 0; j < nestedKeys.length; j++) {
      var child = data[nestedKeys[j]];
      if (child && typeof child === 'object') {
        var nested = findVin(child);
        if (nested) return nested;
      }
    }
    return '';
  }

  function save(regValue, vinValue) {
    var r = cleanReg(regValue), v = cleanVin(vinValue);
    if (!r || v.length < 11) return '';
    try {
      sessionStorage.setItem('sr_vehicle_reg', r);
      sessionStorage.setItem('sr_vehicle_vin', v);
    } catch (e) {}
    return v;
  }

  function storedVinFor(regValue) {
    var r = cleanReg(regValue);
    try {
      var sr = cleanReg(sessionStorage.getItem('sr_vehicle_reg') || '');
      var sv = cleanVin(sessionStorage.getItem('sr_vehicle_vin') || '');
      if (r && sr === r && sv.length >= 11) return sv;
    } catch (e) {}
    return '';
  }

  function lookupVin(regValue) {
    var r = cleanReg(regValue);
    if (!r) return Promise.resolve('');
    var existing = storedVinFor(r);
    if (existing) return Promise.resolve(existing);
    if (lookupPromise) return lookupPromise;

    lookupPromise = fetch('https://touchpoint1.jb-digitals.com/?reg=' + encodeURIComponent(r), {
      method: 'GET',
      credentials: 'omit',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('VIN lookup failed');
        return response.text();
      })
      .then(function (text) {
        var data;
        try { data = JSON.parse(text); } catch (e) { return ''; }
        return save(r, findVin(data));
      })
      .catch(function () { return ''; })
      .then(function (vin) {
        lookupPromise = null;
        return vin;
      });

    return lookupPromise;
  }

  function relevantProductForms() {
    return Array.prototype.slice.call(document.querySelectorAll(
      'form.srp-product-form, form.srpa-product-form, form[action*="/cart/add"]'
    ));
  }

  function putVinOnForm(form, vinValue) {
    var v = cleanVin(vinValue);
    if (!form || v.length < 11) return false;
    var input = form.querySelector('input[name="properties[_VIN]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_VIN]';
      input.setAttribute('data-sr-private-vin', '1');
      form.appendChild(input);
    }
    input.value = v;
    return true;
  }

  function hydrateForms(vinValue) {
    var v = cleanVin(vinValue || storedVinFor(reg));
    if (v.length < 11) return;
    relevantProductForms().forEach(function (form) { putVinOnForm(form, v); });
  }

  function begin() {
    if (!reg) return;

    var existing = storedVinFor(reg);
    if (existing) hydrateForms(existing);

    lookupVin(reg).then(function (vin) {
      if (vin) hydrateForms(vin);
    });
  }

  /* Last-chance guard: if Add to Cart is pressed before the API has returned,
     wait briefly for the VIN, inject the private line-item property, then submit. */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !reg || !form.matches('form.srp-product-form, form.srpa-product-form, form[action*="/cart/add"]')) return;
    if (form.dataset.srVinSubmitReady === '1') {
      form.dataset.srVinSubmitReady = '';
      return;
    }

    var existing = storedVinFor(reg);
    if (existing) {
      putVinOnForm(form, existing);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var timeout = new Promise(function (resolve) { setTimeout(function () { resolve(''); }, 3000); });
    Promise.race([lookupVin(reg), timeout]).then(function (vin) {
      if (vin) putVinOnForm(form, vin);
      form.dataset.srVinSubmitReady = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true });
  else begin();
})();
